import CatalogsLayout from "Components/CatalogsLayout";
import Grid, { SelectColumnFilter, TextFilter } from "Components/Grid";
import Layout from 'Layout'
import React, { CSSProperties, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux';
import Buttons from "Components/Buttons";
import { IBrand } from "Interfaces/IBrand";
import CatalogsModal from "Components/CatalogsModal";
import Modal from "Components/V1/Modal";
import CreateArchivo from "Components/V1/ModalComponents/Archivo/Create";
import ServiceArchivo from "service/archivos";
import EditArchivo from "Components/V1/ModalComponents/Archivo/Edit";
import ConfiguracionMT from "Components/V1/ModalComponents/Archivo/ConfiguracionMT";

const typeModal: any = Object.freeze({
  NEW: "NEW",
  EDIT: "EDIT",
  CONFMT: "CONFMT",
});

// @ts-nocheck
const CatalogoArchivos = () => {
  const { catalogs } = useSelector((state: any) => state.theme);
  const { btnSimple } = useSelector((state: any) => state.theme);



  const [data, setData] = useState([])
  const [isLoadingGrid, setIsLoadingGrid] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [action, setAction] = useState<string>("");
  const [errors, setErrors] = useState<IBrand>({});
  const [formValues, setFormValues] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);




  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [componentActual, setComponentActual] = useState<string>('');
  const [selected, setSelected] = useState<any>();

  useEffect(() => {
    getAll();

  }, [])

  const getAll = () => {
    ServiceArchivo.get(setData)
  }











  const handleNew = () => {
    setComponentActual(typeModal.NEW);
    setTitle("Nuevo Archivo");
    handleChange(true)();
  };
  const handleEdit = (row:any) => {
    setComponentActual(typeModal.EDIT);
    setSelected(row);
    setTitle("Edición de Archivo");
    handleChange(true)();
  };
  const handleConfMT = (row:any) => {
    setComponentActual(typeModal.CONFMT);
    setSelected(row);
    setTitle("Configurar Marcas y Tipo de Operación");
    handleChange(true)();
  };
  const handleChange = (option: boolean = false) => (e?: any) => { setOpen(option) };
  






  const styles: CSSProperties = {
    fontSize: `clamp(1.6rem, 2.5vw, 2rem)`,
    backgroundColor: catalogs.background,
  };

  const handleAdd = () => {
    setAction("add");
    setErrors({});
    /* setFormValues(defaultItem); */
    setOpen(true);
  }

  const columns = [
    {
      accessor: "idArchivo",
      Header: "ID",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "nombreArchivo",
      Header: "Nombre del archivo",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "prefijo",
      Header: "PreFijo",
      Filter: TextFilter,
      filter: "text",
    },
    {
      accessor: "estatus",
      Header: "Estatus",
      Filter: SelectColumnFilter,
      filter: "includes",
    },
  ];
  const config: any = {
    actions: [
      {
        action: "editColumns",
        tooltip: "Admin Columnas",
        visible: true,
        handle: handleEdit,
        color: "#ffb300",
        icon: "edit",
      },
      {
        action: "editMacas",
        tooltip: "Admin Marcas/Tipo Op",
        visible: true,
        handle: handleConfMT,
        color: "#00a176",
        icon: "settings",
      },
    ],
  };

  return (
    <Layout theme={styles}>
      <>
        <CatalogsLayout bannerTitle={'Catálogo de archivos'}>
          <Grid columns={columns} data={data} config={config} isLoading={isLoadingGrid}>
            <Buttons
              title={"Actualizar"}
              type={"add-catalog"}
              config={btnSimple}
              handleClick={getAll}
            />
            <Buttons
              title={"Agregar"}
              type={"add-catalog"}
              config={btnSimple}
              handleClick={handleNew}
            />
          </Grid>
          <Modal
            title={title}
            open={open}
            handleChange={handleChange}
            loader={loading}
            size="60vw"
          >
            {componentActual === typeModal.NEW && (
              <CreateArchivo
                reloadData={getAll}
                closeModal={() => {
                  setComponentActual("");
                  setOpen(false);
                }}
                loading={loading}
                setLoading={setLoading}
              />
            )}
            {componentActual === typeModal.EDIT && (
              <EditArchivo
                reloadData={getAll}
                closeModal={() => {
                  setComponentActual("");
                  setOpen(false);
                }}
                loading={loading}
                setLoading={setLoading}
                row={selected}
              />
            )}
            {componentActual === typeModal.CONFMT && (
              <ConfiguracionMT
                reloadData={getAll}
                closeModal={() => {
                  setComponentActual("");
                  setOpen(false);
                }}
                loading={loading}
                setLoading={setLoading}
                row={selected}
              />
            )}



          </Modal>
        </CatalogsLayout>
      </>
    </Layout>
  )
}

export default CatalogoArchivos